import { render, staticRenderFns } from "./UcrsSwitch.vue?vue&type=template&id=417b22ef"
import script from "./UcrsSwitch.vue?vue&type=script&lang=js"
export * from "./UcrsSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports